var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeekIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 10.125a.625.625 0 0 1 .625-.625h1.25a.625.625 0 0 1 .625.625v1.25a.624.624 0 0 1-.625.625h-1.25a.624.624 0 0 1-.625-.625v-1.25zm-3.75 0a.625.625 0 0 1 .625-.625h1.25a.625.625 0 0 1 .625.625v1.25a.624.624 0 0 1-.625.625h-1.25a.624.624 0 0 1-.625-.625v-1.25zm-6.25 3.75a.625.625 0 0 1 .625-.625h1.25a.625.625 0 0 1 .625.625v1.25a.625.625 0 0 1-.625.625h-1.25a.625.625 0 0 1-.625-.625v-1.25zm3.75 0a.625.625 0 0 1 .625-.625h1.25a.624.624 0 0 1 .625.625v1.25a.624.624 0 0 1-.625.625h-1.25a.625.625 0 0 1-.625-.625v-1.25z",
    fill: "#061C56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 2A.625.625 0 0 1 7 2.625v.625h10v-.625a.625.625 0 1 1 1.25 0v.625h1.25a2.5 2.5 0 0 1 2.5 2.5V19.5a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 2 19.5V5.75a2.5 2.5 0 0 1 2.5-2.5h1.25v-.625A.625.625 0 0 1 6.375 2zM3.25 7v12.5a1.25 1.25 0 0 0 1.25 1.25h15a1.25 1.25 0 0 0 1.25-1.25V7H3.25z",
    fill: "#061C56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeekIcon);
export default __webpack_public_path__ + "static/media/week_icon.6ecf18ac.svg";
export { ForwardRef as ReactComponent };